<svg class="ps-outline-icon" [class.is-filled]="name === 'shield-fill'" viewBox="0 0 24 24" fill="none"
  stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <ng-container [ngSwitch]="name">
    <ng-container *ngSwitchCase="'building'">
      <path d="M4 21V7l8-4 8 4v14"></path>
      <path d="M9 21V12h6v9"></path>
      <path d="M9 9h.01M15 9h.01M9 15h.01M15 15h.01"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'cube'">
      <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"></path>
      <path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'star'">
      <path d="M12 3.2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 15.6 6.2 18.1l.9-5.4L3.2 8.9l5.4-.8L12 3.2z"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'pencil'">
      <path d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3z"></path>
      <path d="M13.5 6.5l3 3"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'chevron-left'">
      <path d="M15 5l-7 7 7 7"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'chevron-down'">
      <path d="M6 9l6 6 6-6"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'chevron-right'">
      <path d="M9 5l7 7-7 7"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'shield'">
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
      <path d="M9 12l2 2 4-4"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'shield-fill'">
      <path class="ps-icon-body"
        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
      <path class="ps-icon-mark" d="M9 12l2 2 4-4"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'download'">
      <path d="M12 4v11"></path>
      <path d="M8 11l4 4 4-4"></path>
      <path d="M5 19h14"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'wrench'">
      <path d="M14.7 6.3a4 4 0 0 0-5.6 5.6L4 17v3h3l5.1-5.1a4 4 0 0 0 5.6-5.6l-2.2 2.2-1.8-1.8 2.2-2.2z"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'plus'">
      <circle cx="12" cy="12" r="8.5"></circle>
      <path d="M12 8v8M8 12h8"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'info'">
      <circle cx="12" cy="12" r="8.5"></circle>
      <path d="M12 11v5M12 8h.01"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'file'">
      <path d="M7 4h7l5 5v11H7V4z"></path>
      <path d="M14 4v5h5"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'cart'">
      <circle cx="9" cy="20" r="1.2"></circle>
      <circle cx="18" cy="20" r="1.2"></circle>
      <path d="M3 4h2l2.4 11.2A2 2 0 0 0 9.4 17H18a2 2 0 0 0 2-1.6L21 8H6"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'target'">
      <circle cx="12" cy="12" r="8.5"></circle>
      <circle cx="12" cy="12" r="4.5"></circle>
      <circle cx="12" cy="12" r="1.3"></circle>
    </ng-container>
    <ng-container *ngSwitchCase="'clipboard'">
      <rect x="6" y="5" width="12" height="15" rx="2"></rect>
      <path d="M9 5V4h6v1"></path>
      <path d="M9 11h6M9 15h4"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'clock'">
      <circle cx="12" cy="12" r="8.5"></circle>
      <path d="M12 7.5V12l3 2"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'calendar'">
      <rect x="4" y="5" width="16" height="15" rx="2"></rect>
      <path d="M8 3v4M16 3v4M4 10h16"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'flag'">
      <path d="M5 21V4"></path>
      <path d="M5 5h10l-2 3.5L15 12H5"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'cloud-download'">
      <path d="M7.5 17H7a4 4 0 0 1 0-8 5.2 5.2 0 0 1 10.1 1.4A3.5 3.5 0 0 1 17.5 17h-1.5"></path>
      <path d="M12 11v7M9.5 15.5L12 18l2.5-2.5"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'chart-line'">
      <path d="M4 19h16"></path>
      <path d="M5 15l4-4 3 3 6-7"></path>
      <path d="M15 7h3v3"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'lightbulb'">
      <path d="M9 18h6M10 21h4"></path>
      <path d="M8.2 14.2A5.5 5.5 0 1 1 15.8 14.2C14.7 15.3 14 16.6 14 18H10c0-1.4-.7-2.7-1.8-3.8z"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'warning'">
      <path d="M12 4l9 16H3L12 4z"></path>
      <path d="M12 10v5M12 17h.01"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'check-circle'">
      <circle cx="12" cy="12" r="8.5"></circle>
      <path d="M8.5 12.2l2.4 2.4 4.6-4.8"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'refresh'">
      <path d="M20 12a8 8 0 1 1-2.3-5.6"></path>
      <path d="M20 5v5h-5"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'link'">
      <path d="M10 13a5 5 0 0 0 7.5.1l1.4-1.4a5 5 0 0 0-7.1-7.1L10.5 6"></path>
      <path d="M14 11a5 5 0 0 0-7.5-.1L5.1 12.3a5 5 0 0 0 7.1 7.1L13.5 18"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'check'">
      <path d="M5.5 12.5l4.2 4.2 8.8-9.4"></path>
    </ng-container>
    <ng-container *ngSwitchCase="'circle'">
      <circle cx="12" cy="12" r="7.5"></circle>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <circle cx="12" cy="12" r="7.5"></circle>
    </ng-container>
  </ng-container>
</svg>
